import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Heart, MessageCircle, ArrowRight } from "lucide-react";

export default function Comunitate() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/stories", { params: { limit: 50 } }).then(r => setItems(r.data || [])).catch(() => {}); }, []);

  return (
    <div data-testid="page-comunitate" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-10 flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Povești reale</p>
          <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Comunitate</h1>
          <p className="mt-4 text-[#A0AABF] text-lg max-w-2xl">Părinți reali. Bunici reali. Lupte reale. Vindecări reale.</p>
        </div>
        <Link to="/spune-povestea" className="btn-gold rounded-sm px-6 py-3 inline-flex items-center gap-2 text-sm">
          Spune povestea ta <ArrowRight className="w-4 h-4" />
        </Link>
      </header>

      {items.length === 0 ? (
        <p className="text-[#A0AABF] italic">Nu există încă povești publicate.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(s => (
            <Link key={s.story_id} to={`/comunitate/${s.story_id}`} data-testid={`com-story-${s.story_id}`} className="cinematic-card rounded-lg p-6 group block">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4A63D] mb-2">{s.county} · {s.relation}</div>
              <h3 className="font-display text-xl text-[#F8F8F4] group-hover:text-[#D4A63D]">{s.title}</h3>
              <p className="text-sm text-[#A0AABF] mt-3 line-clamp-4 leading-relaxed">{s.body}</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-[#6C7A9C]">
                <span className="flex items-center gap-1"><Heart className="w-3 h-3" /> {s.reactions_count}</span>
                <span className="flex items-center gap-1"><MessageCircle className="w-3 h-3" /> {s.comments_count}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
